module.exports = __webpack_public_path__ + "static/media/EleveightLogo.68fce33f.png";